<p nz-typography [nzType]="type">
  <strong>{{ text }}</strong>
</p>
